import { c as _c } from "react/compiler-runtime";
import React, { type SVGProps } from 'react';
type Props = SVGProps<SVGSVGElement> & {
  backgroundColor: string;
  borderColor: string;
};
export const Triangle = React.forwardRef<SVGSVGElement, Props>((t0, ref) => {
  const $ = _c(11);
  let backgroundColor;
  let borderColor;
  let props;
  if ($[0] !== t0) {
    ({
      backgroundColor,
      borderColor,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = backgroundColor;
    $[2] = borderColor;
    $[3] = props;
  } else {
    backgroundColor = $[1];
    borderColor = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== backgroundColor || $[5] !== borderColor) {
    t1 = <path d="M9.83496 7.75C10.7972 6.08335 13.2028 6.08335 14.165 7.75L17.6289 13.75C18.5912 15.4167 17.3884 17.5 15.4639 17.5H8.53613C6.67169 17.5 5.48445 15.5447 6.28711 13.9072L6.37109 13.75L9.83496 7.75Z" fill={backgroundColor} stroke={borderColor} />;
    $[4] = backgroundColor;
    $[5] = borderColor;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== props || $[8] !== ref || $[9] !== t1) {
    t2 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t1}</svg>;
    $[7] = props;
    $[8] = ref;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
});